import IntegrasiMenu from "../../../../../components/categories/superadmin/privilege/integrasi_menu/Home"

export default function Home() {  
  return (
    <IntegrasiMenu />
  );
}
